class EbookCheckout {
  constructor() {
    if(document.querySelector('.ebook-checkout') != null && document.querySelector('.ebook-checkout') != undefined) {
      this.setEvents();
    }
  }

  setEvents() {
    var checkouts = document.querySelectorAll('.ebook-checkout');

    checkouts.forEach(c => {

      // Botões que avançam para o proximo step
      var nextStepButtons = c.querySelectorAll('[checkout-next-step]');
      if(nextStepButtons != null && nextStepButtons != undefined) {
        nextStepButtons.forEach(nsb => {
          nsb.addEventListener('click', function(e) {
            e.preventDefault();
            c.setAttribute('checkout-active-step', nsb.getAttribute('checkout-next-step'));
          });
        });
      }

      // Botões que retornam para o step anterior
      var previousStepButtons = c.querySelectorAll('[checkout-previous-step]');
      if(previousStepButtons != null && previousStepButtons != undefined) {
        previousStepButtons.forEach(psb => {
          psb.addEventListener('click', function(e) {
            e.preventDefault();
            c.setAttribute('checkout-active-step', psb.getAttribute('checkout-previous-step'));
          });
        });
      }
      
      // Step 3 ->  Radios de método de pagamento
      var pm_radios = c.querySelectorAll('input[name=pm]');
      if(pm_radios != null && pm_radios != undefined) {
        pm_radios.forEach(pmr => {
          pmr.addEventListener('change', function() {
            c.querySelector('.ebook-checkout__payment').classList.remove('pm1');
            c.querySelector('.ebook-checkout__payment').classList.remove('pm2');
            c.querySelector('.ebook-checkout__payment').classList.add(pmr.getAttribute('id'));
          });
        });
      }

      // Step 3 -> Checkbox de aceito condições
      var p_checkbox = c.querySelector('input[id=pgc]');
      var p_checkbutton = c.querySelector('.payment__checkbutton');
      if(p_checkbox != null && p_checkbox != undefined) {
        p_checkbox.addEventListener('change', function() {
          if(p_checkbox.checked) {
            p_checkbutton.classList.remove('disabled');
          } else {
            p_checkbutton.classList.add('disabled');
          }
        });
      }

    });

  }
}

const ebookCheckout = new EbookCheckout();
